module.exports = {
    // account delete confirmation
    "You can request deletion of your account <strong class='nickname'>%1</strong> by clicking the button below." :
        "Supprimez votre compte <strong class='nickname'>%1</strong> en cliquant sur le bouton ci-dessous.",
    "All data in this account will be deleted as soon as possible by the administrator (subscription, photos, videos, email addresses ...)" :
        "Toutes les données rattachées à ce compte seront rapidement supprimées (abonnement, photos, vidéos, adresses émail, numéro de téléphone...)",
    "WARNING: Your request will not be cancelable, it will not be possible to access your account, your data and your subscription after its removal." :
        "ATTENTION : Cette action est irréversible, il ne vous sera plus possible d'accéder à ce compte.",
    "Your request is received. You will get a confirmation by email %1 and by phone %2 when the administrator deletes your account." :
        "Votre demande est prise en compte. Vous recevrez un confirmation par email %1 et par téléphone %2 dès que l'administrateur aura supprimé votre compte.",
    "Your request is received. You will get a confirmation by email %1 when the administrator deletes your account." :
        "Votre demande est prise en compte. Vous recevrez un confirmation par email %1 dès que l'administrateur aura supprimé votre compte.",

    // wall material/video delete confirmation

    'Do you really want to delete <strong class=\'nickname\'>%1</strong>?': 'Do you really want to delete <strong class=\'nickname\'>%1</strong>?',
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/delete.js